import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import { Link } from "gatsby";
import logo from "../images/asg-logo.png";
import NavigationIcon from "./navigation-icon";
var _default = /*#__PURE__*/ function (_React$Component) {
    _inheritsLoose(_default, _React$Component);
    function _default() {
        var _this;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
        _this.state = {
            navOpen: false
        };
        return _this;
    }
    var _proto = _default.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.watchWindowResize();
    };
    _proto.watchWindowResize = function watchWindowResize() {
        var _this2 = this;
        window.addEventListener("resize", function () {
            return _this2.setState({
                navOpen: false
            });
        });
    };
    _proto.render = function render() {
        var _this3 = this;
        return /*#__PURE__*/ React.createElement("nav", {
            className: "nav"
        }, /*#__PURE__*/ React.createElement("ul", null, /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Link, {
            to: "/"
        }, /*#__PURE__*/ React.createElement("img", {
            src: logo,
            alt: "American Softgels Inc. Logo"
        }))), /*#__PURE__*/ React.createElement(NavigationIcon, {
            onNavClick: function onNavClick() {
                return _this3.setState({
                    navOpen: !_this3.state.navOpen
                });
            }
        }), /*#__PURE__*/ React.createElement("div", {
            className: "nav__dropdown " + (this.state.navOpen && "nav__dropdown--open")
        }, /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Link, {
            to: "/"
        }, "Home")), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Link, {
            to: "/why-softgels"
        }, "Why Softgels")), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Link, {
            to: "/products"
        }, "Products")), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Link, {
            to: "/contact-us"
        }, /*#__PURE__*/ React.createElement("button", null, "Contact Us"))))));
    };
    return _default;
}(React.Component);
export { _default as default };
